var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{staticClass:"impersonate-bar"},[_c('a',{attrs:{"href":"/impersonate/stop","rel":"no-follow"}},[_c('div',{staticClass:"container-fluid"},[_vm._v("\n            You are currently impersonating "),_c('strong',[_vm._v(_vm._s(_vm.user.name))]),_vm._v(", click this bar to stop\n        ")])])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-196b47c0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Elements/ImpersonateBar.vue
// module id = 3/Nj
// module chunks = 0